import { render, staticRenderFns } from "./ThreatsTable.vue?vue&type=template&id=f216d7d8&"
import script from "./ThreatsTable.vue?vue&type=script&lang=js&"
export * from "./ThreatsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports